import { UsersConfig } from './users.abstract.config';

export const usersConfig: UsersConfig = {
  privileges: {},
};
